export var globalInstance = {};
export var setGlobalInstance = function (instanceId, graph) {
    globalInstance[instanceId] = graph;
};
export var getGlobalInstance = function (instanceId) {
    return globalInstance[instanceId];
};
